import React from 'react'
import { FormFieldType } from '@App/forms/v2/common/form-field'
import FormFieldFromProps from '@App/kit/fields/v2/FormFieldFromProps'

interface UserInfoProps {
    firstName: FormFieldType<string>
    lastName: FormFieldType<string>
    birthday: FormFieldType<Date | undefined>
}

const UserInfoSection = (props: UserInfoProps) => {
    const { firstName, lastName, birthday } = props

    return (
        <div className="user-info-wrapper info-wrapper">
            <h5>User Information</h5>
            <div className="inputs-area">
                <FormFieldFromProps field={firstName} />
                <FormFieldFromProps field={lastName} />
                <FormFieldFromProps field={birthday} />
            </div>
        </div>
    )
}

export default UserInfoSection
